export default "__VITE_ASSET__CLnUcmdf__$_?format=webp__"